import React from 'react'
import { Badge } from 'antd'
import type { DefaultOptionType } from 'antd/es/cascader'

// 递归提取所有 label 文本
export function extractLabelText(label: any): string {
  if (typeof label === 'string') return label
  if (React.isValidElement(label) && label.props) {
    const children = (label.props as { children?: any }).children
    if (typeof children === 'string') return children
    if (Array.isArray(children)) {
      return children.map(extractLabelText).join('')
    }
    if (children) return extractLabelText(children)
  }
  return ''
}

// 安全设备过滤
export const deviceFilter = (inputValue: string, path: DefaultOptionType[]) => {
  const searchValue = inputValue.toLowerCase()
  return path.some(option => {
    const labelText = extractLabelText(option.label).toLowerCase()
    return labelText.includes(searchValue)
  })
}

// 站点选择 - 现在是两级结构：设备类型 -> 设备
export const createCascaderDeviceListData = (securityDeviceData: any[]) =>
  securityDeviceData.map(deviceType => {
    // 按状态分组设备
    const onlineDevices = deviceType.devices.filter(
      device => device.deviceStatus === 'DatasourceClientStatusOnline',
    )
    const offlineDevices = deviceType.devices.filter(
      device => device.deviceStatus !== 'DatasourceClientStatusOnline',
    )

    return {
      value: deviceType.deviceType,
      label: (
        <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <span>{deviceType.deviceType}</span>
          {deviceType.devices.length > 0 && (
            <span style={{ color: '#4238C9', marginLeft: '8px' }}>
              ({deviceType.devices.length})
            </span>
          )}
        </span>
      ),
      selectable: false, // 第一层不可选择
      children: [...onlineDevices, ...offlineDevices].map(device => ({
        value: device.deviceId,
        disabled: device.deviceStatus !== 'DatasourceClientStatusOnline',
        label: (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <span>
              {device.deviceName}|{device.deviceIp}
            </span>
            <Badge
              style={{ marginLeft: 10 }}
              status={
                device.deviceStatus === 'DatasourceClientStatusOnline' ? 'success' : 'default'
              }
            />
          </span>
        ),
        device: {
          deviceId: device.deviceId,
          deviceName: device.deviceName,
          deviceIp: device.deviceIp,
          deviceStatus: device.deviceStatus,
        },
      })),
    }
  })

// 自定义显示渲染函数
export const displayRender = (labels: string[], selectedOptions?: DefaultOptionType[]) => {
  if (!selectedOptions || selectedOptions.length === 0) return ''

  // 单选模式，获取最后一个选项（设备选项）
  const deviceOption = selectedOptions[selectedOptions.length - 1]
  if (deviceOption?.device) {
    return `${deviceOption.device.deviceName}|${deviceOption.device.deviceIp}`
  }

  return labels[labels.length - 1] || ''
}
